import "./header.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    const burger = document.getElementById("menu_burger");
    const header = document.getElementById("header");

    burger.addEventListener("click", () => {
      header.classList.toggle("menu_opened");
    });

    const updateHeaderColor = () => {
      if (window.scrollY + 114 > window.innerHeight) {
        header.classList.add("header_scrolled");
      } else {
        header.classList.remove("header_scrolled");
      }
    };
    updateHeaderColor();
    window.addEventListener("scroll", () => {
      updateHeaderColor();
    });
  },
  false
);
